import './component.scss';

export class NewsListSliderHightop {

    constructor(id, params = {}, result = {}, options = {}) {
        this.id = id
        this.params = params
        this.result = result
        this.options = options
        this.$component = document.getElementById(this.id)

        this.init()
    }

    init() {
        this.initSlider()
    }

    initSlider() {
        let selector = `#${this.id} .js-slider`

        this.$slider = new Swiper(selector, {
            autoHeight: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.js-slider-next',
                prevEl: '.js-slider-prev',
            },
            breakpoints: {
                1266: {
                    autoHeight: false,
                }
            }
        })
    }

}
